module.exports = __webpack_public_path__ + "img/淋浴区整面踏板.2db2280b.webp";